import React from 'react';
import RadixMenu from '../Common/RadixMenu/RadixMenu';
import { 
    EllipsisVerticalIcon,
    PencilIcon,
    EyeIcon,
    TrashIcon
} from '@heroicons/react/24/outline';

const PopupActionsMenu = ({ 
    popup,
    onEdit,
    onPreview,
    onDelete
}) => {
    // Actions du menu déroulant
    const menuItems = [
        {
            label: "Modifier",
            icon: <PencilIcon className="w-4 h-4" />,
            onClick: onEdit
        },
        {
            label: "Prévisualiser",
            icon: <EyeIcon className="w-4 h-4" />,
            onClick: onPreview
        },
        { divider: true },
        {
            label: "Supprimer",
            icon: <TrashIcon className="w-4 h-4" />,
            onClick: onDelete,
            danger: true
        }
    ];

    // Trigger du menu
    const trigger = (
        <button className="btn btn-primary btn-sm btn-circle relative">
            <EllipsisVerticalIcon className="w-5 h-5 transition-all" />
        </button>
    );

    return (
        <div className="z-50 relative flex flex-shrink-0">
            <RadixMenu
                trigger={trigger}
                items={menuItems}
                side="bottom"
                align="end"
                width="w-56"
            />
        </div>
    );
};

export default PopupActionsMenu; 